export default "//yastatic.net/s3/distribution/pythia/frontend/_/b983d7f3dad72124c7801d5cb5858824.png";